var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagicPrzerwa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD92D"
    },
    d: "M181.585,75.805L169.45,23.628c-1.58-6.72,3.517-13.157,10.421-13.157h98.409 c6.836,0,11.921,6.321,10.457,12.999l-11.534,52.335H181.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA81E"
    },
    d: "M278.232,10.471h-98.408c-6.901,0-11.999,6.439-10.422,13.157l1.191,5.036h47.25 c24.822,0,43.281,22.896,37.959,47.14l0,0h21.355l11.536-52.33C290.159,16.796,285.073,10.471,278.232,10.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#956EC4"
    },
    d: "M351.626,152.895l1.957,36.543l52.463,49.924l42.309-50.77l-44.001-45.693l-42.453-0.674 C356.032,142.132,351.312,147.033,351.626,152.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8F8F8"
    },
    d: "M281.309,183.007v-64.298H178.481v64.298C113.31,204.58,66.238,265.895,66.238,338.302 c0,90.386,73.271,163.658,163.658,163.658s163.658-73.273,163.658-163.658C393.553,265.895,346.48,204.578,281.309,183.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF328F"
    },
    d: "M108.268,265.361c-12.435,21.116-19.698,45.645-19.698,71.926c0,78.475,63.618,142.09,142.093,142.09 s142.093-63.616,142.093-142.09c0-26.28-7.264-50.809-19.698-71.926H108.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF73B1"
    },
    d: "M111.595,327.467c0-21.902,4.284-42.691,11.429-62.106h-14.577 c-12.435,21.116-19.698,45.645-19.698,71.925c0,60.913,38.401,112.723,92.259,132.929 C138.79,436.911,111.595,385.411,111.595,327.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E80D6B"
    },
    d: "M353.693,265.361h-21.816c8.241,19.975,12.955,41.763,12.955,64.717 c0,61.475-32.495,115.23-81.139,145.444c62.839-14.678,109.697-70.927,109.697-138.238 C373.391,311.006,366.127,286.478,353.693,265.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E1E4"
    },
    d: "M283.738,119.531H176.051c-11.833,0-21.426-9.593-21.426-21.426v-0.588 c0-11.833,9.593-21.426,21.426-21.426h107.687c11.833,0,21.426,9.593,21.426,21.426v0.588 C305.164,109.939,295.571,119.531,283.738,119.531z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF73B1"
    },
    cx: 245.055,
    cy: 218.821,
    r: 17.264
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF73B1"
    },
    cx: 196.811,
    cy: 235.74,
    r: 13.121
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF73B1"
    },
    cx: 223.045,
    cy: 175.668,
    r: 13.16
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF73B1"
    },
    d: "M305.925,311.609c-3.56-3.563-8.216-5.35-12.871-5.375l0.472-0.523 c-0.247-4.186-1.72-7.472-4.928-10.68c-6.931-6.931-18.132-6.97-25.018-0.086c-6.882,6.884-6.843,18.084,0.089,25.013 l-72.244,73.003c-7.145-7.141-18.682-7.18-25.772-0.088c-7.095,7.093-7.055,18.632,0.084,25.772 c3.555,3.551,8.191,5.331,12.832,5.366l-0.475,0.529c0.253,4.186,1.77,7.475,4.977,10.684c6.931,6.931,18.132,6.968,25.018,0.086 c6.882-6.884,6.841-18.084-0.089-25.015l72.244-73.002c7.145,7.139,18.677,7.18,25.772,0.087 C313.11,330.287,313.069,318.75,305.925,311.609z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C2042"
    },
    d: "M375.276,265.299c-4.931,2.118-7.209,7.831-5.093,12.762c0.772,1.797,1.521,3.64,2.227,5.477 c1.485,3.863,5.166,6.235,9.071,6.235c1.158,0,2.337-0.209,3.482-0.649c5.008-1.924,7.51-7.545,5.585-12.553 c-0.795-2.073-1.641-4.151-2.512-6.178C385.92,265.46,380.204,263.178,375.276,265.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C2042"
    },
    d: "M454.024,181.096l-44.001-45.692c-1.794-1.863-4.258-2.936-6.844-2.976l-52.204-0.829 c-4.506-1.104-21.767-5.248-36.129-7.516c-3.73-0.588-7.642-1.823-11.368-3.306c6.214-5.505,10.144-13.535,10.144-22.472 c0-15.507-11.817-28.304-26.918-29.864l9.574-43.645c1.332-6.073-0.139-12.334-4.034-17.177S282.545,0,276.328,0h-98.409 c-6.277,0-12.112,2.822-16.008,7.742s-5.308,11.247-3.871,17.357l10.276,43.672c-14.007,2.534-24.667,14.809-24.667,29.536 c0,14.441,10.25,26.53,23.855,29.384v48.77c-67.428,25.368-112.245,89.665-112.245,162.164C55.258,434.224,133.034,512,228.633,512 s173.375-77.776,173.375-173.375c0-5.367-4.35-9.716-9.716-9.716c-5.366,0-9.716,4.349-9.716,9.716 c0,84.884-69.059,153.943-153.943,153.943S74.691,423.509,74.691,338.625c0-66.466,42.43-125.167,105.582-146.071 c3.977-1.318,6.663-5.034,6.663-9.224v-54.58h83.396v54.58c0,4.19,2.686,7.908,6.663,9.224 c29.603,9.798,55.277,28.148,74.25,53.063c3.252,4.269,9.35,5.096,13.617,1.843c4.27-3.25,5.095-9.347,1.843-13.617 c-19.921-26.161-46.411-45.893-76.94-57.382V135.96c6.556,3.101,14.398,6.11,22.051,7.317c9.796,1.547,21.37,4.103,28.586,5.78 l2.151,40.143c0.133,2.477,1.207,4.809,3.004,6.519l52.463,49.924c1.811,1.723,4.212,2.676,6.698,2.676 c0.187,0,0.374-0.005,0.561-0.017c2.683-0.154,5.183-1.415,6.904-3.48l42.309-50.77 C457.661,190.249,457.462,184.665,454.024,181.096z M177.143,19.807c0.298-0.374,0.658-0.374,0.776-0.374h98.409 c0.117,0,0.474,0,0.771,0.369c0.297,0.368,0.22,0.718,0.196,0.832l-10.452,47.649h-78.678l-11.209-47.635 C176.929,20.533,176.846,20.182,177.143,19.807z M163.08,98.307c0-5.84,4.752-10.592,10.592-10.592h109.922 c5.84,0,10.592,4.752,10.592,10.592c0,5.84-4.752,10.592-10.592,10.592H173.672C167.832,108.899,163.08,104.147,163.08,98.307z M403.896,224.413l-42.147-40.107l-1.775-33.128l38.854,0.617l35.16,36.511L403.896,224.413z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M178.058,449.072c-2.004,0-4.026-0.618-5.764-1.899c-27.467-20.278-41.441-40.57-53.971-64.8 c-2.465-4.767-0.6-10.628,4.166-13.093c4.769-2.464,10.628-0.6,13.093,4.168c11.605,22.439,23.726,39.984,48.253,58.092 c4.318,3.188,5.234,9.271,2.046,13.587C183.977,447.708,181.036,449.072,178.058,449.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M115.84,357.591c-4.222,0-8.107-2.772-9.333-7.032l-0.289-0.999 c-0.253-0.867-0.253-0.867-0.462-1.742l-0.244-1.009c-1.27-5.213,1.928-10.469,7.141-11.74c5.213-1.273,10.47,1.928,11.74,7.142 l0.258,1.069c0.102,0.426,0.102,0.426,0.225,0.847l0.306,1.056c1.485,5.156-1.494,10.541-6.651,12.025 C117.635,357.468,116.73,357.591,115.84,357.591z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicPrzerwa);
export default __webpack_public_path__ + "static/media/magic_przerwa.47efd7cb5b830c641af225e8a5c00bc2.svg";
export { ForwardRef as ReactComponent };